<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12 v-if="!vertical">
        <material-card color="green" :title="tableTitle">
          <v-data-table :headers="columnsToShow" :items="data" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td v-for="key in columnsToShow" v-bind:key="key">
                <template v-if="key.value == routerLinkKey">
                  <router-link
                    :to="'/' + routerLinkPath + '/' + item[key.value]"
                  >{{item[key.value]}}</router-link>
                </template>
                <template v-else>{{item[key.value]}}</template>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 v-if="vertical">
        <material-card color="green" :title="tableTitle">
          <v-data-table :headers="verticleColumnsToShow" :items="columnsToShow" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{item.value}}</td>

              <template v-if="includes(data[0][item.value],'background-color')">
                <td :style="data[0][item.value]"></td>
              </template>
              <template v-else>
                <td>{{data[0][item.value]}}</td>
              </template>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Array,
    columns: Array,
    routerLinkPath: String,
    routerLinkKey: String,
    vertical: Boolean,
    tableTitle: String
  },
  data() {
    return {
      verticleColumnsToShow: [
        { text: "Field", value: "Field" },
        { text: "Value", value: "Value" }
      ]
    }
  },
  methods: {
    includes: function(x, y) {
      return String(x).indexOf(y) > -1
    }
  },
  computed: {
    columnsToShow: function() {
      var arr = []
      if (this.columns != null) {
        arr = this.columns
      } else if (this.data != null && this.data.length > 0) {
        arr = Object.keys(this.data[0])
      }

      var columns = []
      for (var i = 0; i < arr.length; i++) {
        columns.push({ text: arr[i], value: arr[i] })
      }

      return columns
    }
  }
}
</script>
